// Toont één storytellingbestand: een video als video, al het andere als
// afbeelding. Gedeeld door de mediatab en de tab 'Te beoordelen', zodat een
// video op beide plekken hetzelfde verschijnt (tot 2026-10-30 stond een video
// in de mediatab als <img>, en toonde dus niets).
// AI-CONTEXT: See docs/features/storytelling-deellink.md

/**
 * @param {object} props
 * @param {string} props.src - Url van het bestand
 * @param {string} [props.type] - MIME-type, bijv. 'video/mp4'; leeg = afbeelding (oude items)
 * @param {string} [props.alt] - Beschrijving; bij een video de naam voor schermlezers
 * @param {string} [props.id] - Optioneel id, voor de bestaande opmaak in de tabel
 * @param {string} [props.className]
 */
const StorytellingMediaPreview = ({ src, type = '', alt = '', id, className }) => (
    String(type).startsWith('video/')
        // preload="metadata": alleen de eerste beelden, niet de hele video bij het openen van de tab.
        ? <video id={id} className={className} src={src} aria-label={alt || undefined} controls preload="metadata" />
        // loading="lazy": een lange lijst laadt niet alle originelen tegelijk.
        : <img id={id} className={className} src={src} alt={alt} loading="lazy" />
)

export default StorytellingMediaPreview
